export enum TariffCode {
  LOCK_CYLINDER = "83014011",
  PADLOCK = "83011000",
  KEY = "83017000",
  CHIP_ELECTRONICS = "85423990",
  ELECTRONIC_DEVICE = "85437090",
  METAL_ACCESSORY = "83024110",
}
